import React from 'react';

import { ScrollArea } from '@mantine/core';
import { IconShoppingCart } from '@tabler/icons-react';
import { useQuery } from '@tanstack/react-query';
import { AddStoreButton } from 'components/AddStoreButton';
import { ErrorAlert } from 'components/ErrorAlert';
import { FullScreenLoader } from 'components/FullScreenLoader';
import { NoDataFound } from 'components/NoDataFound';
import { SettingsSectionWrapper } from 'pages/Settings/SettingTabs/SettingsSectionWrapper';
import { ShopifyStoreDetails } from 'pages/Settings/SettingTabs/StoresSettingsTab/ShopifyStoreDetails';
import { ShopifyStoreTile } from 'pages/Settings/SettingTabs/StoresSettingsTab/ShopifyStoreTile';
import queryString from 'query-string';
import { useTranslation } from 'react-i18next';
import { ShopifyService } from 'services/shopify-service';
import { SHOPIFY_STORES_QUERY_KEY } from 'shared/constants/query-keys';

export function StoresSettingsTab() {
  const { t } = useTranslation();
  const { store } = queryString.parse(location.search);

  const shopifyStoresQuery = useQuery({
    queryFn: ShopifyService.getAllStores,
    queryKey: [SHOPIFY_STORES_QUERY_KEY]
  });

  if (shopifyStoresQuery.isInitialLoading) return <FullScreenLoader />;
  if (shopifyStoresQuery.isError) return <ErrorAlert />;
  const shopifyStores = shopifyStoresQuery.data || [];

  if (typeof store === 'string' && store.trim() !== '') return <ShopifyStoreDetails storeId={store} />;

  const hasStores = shopifyStores.length > 0;

  return (
    <>
      <SettingsSectionWrapper
        title={t('STORES.CONNECTED_STORES')}
        rightComponent={hasStores && <AddStoreButton />}
        h="100%">
        {!hasStores ? (
          <NoDataFound
            h="100%"
            size="xs"
            title={t('NO_DATA_FOUND.STORES.TITLE')}
            subTitle={t('NO_DATA_FOUND.STORES.SUB_TITLE')}
            icon={<IconShoppingCart />}
            button={<AddStoreButton />}
          />
        ) : (
          <ScrollArea h="100%">
            {shopifyStores.map((store, idx) => (
              <ShopifyStoreTile
                key={idx}
                mt={idx === 0 ? 0 : 5}
                mb={idx === shopifyStores.length - 1 ? 0 : 5}
                shopifyStore={store}
              />
            ))}
          </ScrollArea>
        )}
      </SettingsSectionWrapper>
    </>
  );
}
